<template>
  <div class="password_page">
    <div class="content">
      <div class="title">
        请输入测试密码：
      </div>
      <div class="inputs">
        <input type="text" ref="password" class="password"/>
        <button class="submit" @click.prevent="submit">提交</button>
      </div>
      <div class="tips">
        本页面仅供内部测试使用，请勿外传！
      </div>
    </div>
  </div>
</template>
<script>
  import * as Cookie from 'tiny-cookie'
  import {TEST_PASSWORD} from '../constant/CookieKeys'

  const test_password = 'mgtvvip';

  export default {
    name: 'TestPassword',
    props: {},
    data() {
      return {}
    },
    methods: {
      submit() {
        console.log(this.$refs.password.value)
        if (this.$refs.password.value === test_password) {
          Cookie.set(TEST_PASSWORD, test_password, {expires: '1Y'});
          window.$bus.is_need_test_password = false;
        } else {
          window.$toast('密码错误');
        }
      }

    },
    created() {

    },
    computed: {},
    mounted() {

    },
    watch: {}
  }
</script>
<style lang="stylus" scoped>
  .password_page
    width 7.5rem
    height 100vh
    position relative
    background url(//i5.hitv.com/s1/2017/userimg/background.jpg?433202.9877041667) no-repeat
    background-size 100% auto
    overflow hidden
    color #666
    .content
      background white
      width 6rem
      height 3rem
      position absolute
      border-radius 5%
      margin 0 auto
      top 5rem
      left .75rem
      border 2px solid #ffc448
      padding .1rem
      .title
        padding-top .2rem
        font-size .4rem
        text-align center
        color #666
      .inputs
        display flex
        align-items center
        justify-content center
        margin-top .2rem
        .password
          height .5rem
          width 3.5rem
          font-size .4rem
          margin-right .2rem
          color #666
        .submit
          font-size .4rem
          color #666
      .tips
        position absolute
        font-size .22rem
        text-align center
        color #666
        margin-top .2rem
        width 100%

</style>



